<div  mat-dialog-content>
 
    <!--Order Cancel are You want to cancel option here section-->
    <div class="fixed inset-0 z-40 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center">
        <!-- overlay -->
        <div aria-hidden="true" class="fixed inset-0 w-full h-full bg-black/50 cursor-pointer">
        </div>
        <div class="relative w-full cursor-pointer pointer-events-none transition my-auto p-4">
        <form #myForm="ngForm">
        <!-- Modal -->
            <div
                class="w-full py-2 bg-white cursor-default pointer-events-auto dark:bg-white relative rounded-xl mx-auto max-w-sm">
    
                <button tabindex="-1" type="button" class="absolute top-2 right-2 rtl:right-auto rtl:left-2" [mat-dialog-close]="true" >
                    <svg title="Close" tabindex="-1" class="h-4 w-4 cursor-pointer text-gray-400 dark:text-black"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <span class="sr-only">
                        Close
                    </span>
                </button>
    
    
    
                <div class="space-y-2 p-2" *ngIf="showPage">
                    <div class="p-4 space-y-2 text-center dark:text-black">
                        <h2 class="text-xl font-bold tracking-tight" id="page-action.heading">
                            Order Cancel
                        </h2>
    
                        <p class="text-gray-500 dark:text-black">
                            Are you sure would like to Cancel Order? Click bellow Next button!
                        </p>
                    </div>
                </div>

                
                <div class="space-y-2 p-2" *ngIf="!showPage" (ngSubmit)="cancelOrder()" >
                    <h2 class="text-xl  text-center font-bold tracking-tight" id="page-action.heading">
                        Order Cancel 
                    </h2>
                            <p>Why You Want to Cancel Order please give the <b class="font-semibold text-red-600">Resoan ?</b></p>
                            
                            <div class="flex items-center ps-4 border border-gray-200 rounded dark:border-black" >
                                <input  type="radio" id="option1" name="choice" value="Delivery Related Issue" [(ngModel)]="selectedChoice" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 ">
                                <label for="option1" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-black">Delivery Related Issue</label>
                            </div>
                            <div class="flex items-center ps-4 border border-gray-200 rounded dark:border-black" >
                                <input  type="radio" id="option2" name="choice" value="packging Related Issue" [(ngModel)]="selectedChoice" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 ">
                                <label for="option2" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-black">packging Related Issue</label>
                            </div>
                            <div class="flex items-center ps-4 border border-gray-200 rounded dark:border-black" >
                                <input  type="radio" id="option3" name="choice" value="Product very Expensive" [(ngModel)]="selectedChoice" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 ">
                                <label for="option3" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-black">Product very Expensive</label>
                            </div>
                            <div class="flex items-center ps-4 border border-gray-200 rounded dark:border-black">
                                <input  type="radio" id="option4" name="choice" value="Wrong/demange Product" [(ngModel)]="selectedChoice" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 ">
                                <label for="option4" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-black">Wrong/demange Product</label>
                            </div>
                            <div (click)="togglePageinput(true)">
                            <div class="flex items-center ps-4 border border-gray-200 rounded dark:border-black" >
                                <input  type="radio" id="option5" name="choice" value="Other Issue" [(ngModel)]="selectedChoice" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 " (click)="togglePageinput(true)">
                                <label for="option5" class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-black">Other Issue</label>
                            </div>
                            </div>
                <div *ngIf="!showInput" >
                   <!-- <input type="text"  [(ngModel)]="otherIssue"  id="otherIssue" class="bg-white border border-purple-600 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Type Resoan" required="true" /> -->
                   <!-- <div>
                    <input type="text" [(ngModel)]="otherIssue"  id="otherIssue" class="bg-white border border-purple-600 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Type Reason" required>
                    <div *ngIf="['otherIssue'].invalid && form.controls['otherIssue'].touched">
                      <small *ngIf="form.controls['otherIssue'].errors?.required" class="text-red-600">Reason is required.</small>
                      <small *ngIf="form.controls['otherIssue'].errors?.minlength" class="text-red-600">Reason must be at least 3 characters long.</small>
                    </div>
                  </div> -->
                  <div>
                   
                        <label for="otherIssue">Type Reason:</label>
                        <input type="text" id="otherIssue" name="otherIssue" [(ngModel)]="otherIssue"
                          required minlength="5"
                          class="bg-white border border-purple-600 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-white dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          (ngModelChange)="onInputChange()" #otherIssueCtrl="ngModel" placeholder="write something....">
                        <div *ngIf="otherIssueCtrl.invalid && otherIssueCtrl.touched">
                          <small *ngIf="otherIssueCtrl.errors?.['required']" class="text-red-600">Reason is required.</small>
                          <small *ngIf="otherIssueCtrl.errors?.['minlength']" class="text-red-600">Reason must be at least 5 characters  or long.</small>
                        </div>
                      </div>
                </div>
             
<input
  type="file"
  accept="video/*"
  (change)="videoFile = $event.target.files[0]"
  *ngIf="orderdata?.order_status === 'Delivered' && isWithin7Days(orderdata?.createdAt)"
/>




    </div>
                <div class="space-y-2">
                    <div aria-hidden="true" class="border-t dark:border-gray-700 px-2"></div>
    
                    <div class="px-6 py-2">
                        <div class="grid gap-2 grid-cols-[repeat(auto-fit,minmax(0,1fr))]">
                            <button type="button" [mat-dialog-close]="true" 
                                    class="inline-flex items-center justify-center py-1 gap-1 font-medium rounded-lg border transition-colors outline-none  dark:focus:ring-offset-0 min-h-[2.25rem] px-4 text-sm text-gray-800 bg-white border-purple-700 hover:bg-purple-500 focus:ring-primary-600 focus:text-primary-600 focus:bg-primary-50 focus:border-primary-600 dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-600 dark:hover:border-gray-500 dark:text-gray-200 dark:focus:text-primary-400 dark:focus:border-primary-400 dark:focus:bg-gray-800">
                                    <span class="flex items-center gap-1">
                                        <span class="">
                                            No
                                        </span>
                                    </span>
                                </button>
    
                            <button type="button"  (click)="togglePage()" *ngIf="showPage"
                                    class="btncolor inline-flex items-center justify-center py-1 gap-1 font-medium rounded-lg border transition-colors outline-none focus:ring-offset-2 focus:ring-2 focus:ring-inset dark:focus:ring-offset-0 min-h-[2.25rem] px-4 text-sm text-white shadow focus:ring-white border-transparent  hover:bg-purple-500 focus:bg-purple-700 focus:ring-offset-purple-700">
                                    <span class="flex items-center gap-1">
                                        <span class="">
                                            Next
                                        </span>
                                    </span>
    
                                </button>
                            <button    *ngIf="!showPage"   [disabled]="myForm.invalid" mat-button type="submit" [mat-dialog-close]="true" 
                                    class="btncolor inline-flex items-center justify-center py-1 gap-1 font-medium rounded-lg border transition-colors outline-none focus:ring-offset-2 focus:ring-2 focus:ring-inset dark:focus:ring-offset-0 min-h-[2.25rem] px-4 text-sm text-white shadow focus:ring-white border-transparent  hover:bg-purple-500 focus:bg-purple-700 focus:ring-offset-purple-700">
    
                                    <span class="flex items-center gap-1" (click)="orderCancel()">
                                        <span class="text-white">
                                            Submit
                                        </span>
                                    </span>
    
                                </button>
                        </div>
                    </div>
                </div>
          

            </div>
            </form>
        </div>

    
    </div>

<!--Order Cancel Select option here section-->





  </div>
  
              